import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/contact')({
  validateSearch: (search: Record<string, unknown>) => ({
    type: typeof search.type === 'string' ? search.type : undefined,
  }),
});

